import { useMutation, useQueryClient } from "react-query";
import {
  approveOrRejectGR,
  approveOrRejectPO,
  createGoodsReceived,
  createPO,
  deleteGoodsReceived,
  deletePO,
  downloadPO,
  sendPOEmail,
  updateFulfillmentPO,
  updateGoodsReceived,
  updatePurchaseOrder,
  updatePricingViaPO,
  downloadGR,
  createBills,
  downloadBills,
  deleteBills,
  approveOrRejectBills,
  updateBills,
  createPOCategory,
  updatePOCategory,
  deletePOCategory,
  updatePOSupplier,
} from "../../../services/procurement";

export const useCreatePOMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createPO(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPurchaseOrders"]);
    },
  });
};

export const useUpdatePOMutation = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updatePurchaseOrder(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPurchaseOrders"]);
      queryClient.invalidateQueries(["getPurchaseOrderDetails", `${id}`]);
      queryClient.invalidateQueries(["getPurchaseOrderItems", `${id}`]);
      queryClient.invalidateQueries(["getPOGoodsReceivedItems", `${id}`]);
    },
  });
};

export const useApproveOrRejectPOMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => approveOrRejectPO(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPurchaseOrders"]);
    },
  });
};

export const useDownloadPOMutation = () => {
  return useMutation((data) => downloadPO(data));
};

export const useDeletePOMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deletePO(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPurchaseOrders"]);
    },
  });
};

export const useUpdateFulfillmentPOMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateFulfillmentPO(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPurchaseOrders"]);
    },
  });
};

export const useSendPOEmailMutation = () => {
  return useMutation((data) => sendPOEmail(data));
};

export const useUpdatePricingViaPOMutation = () => {
  return useMutation((data) => updatePricingViaPO(data));
};

export const useCreateGRMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createGoodsReceived(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getGoodsReceived"]);
    },
  });
};

export const useUpdateGRMutation = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateGoodsReceived(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getGoodsReceived"]);
      queryClient.invalidateQueries(["getGoodsReceivedDetails", `${id}`]);
      queryClient.invalidateQueries(["getGoodsReceivedItems", `${id}`]);
    },
  });
};

export const useApproveOrRejectGRMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => approveOrRejectGR(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getGoodsReceived"]);
    },
  });
};

export const useDeleteGRMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteGoodsReceived(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getGoodsReceived"]);
    },
  });
};

export const useDownloadGRMutation = () => {
  return useMutation((data) => downloadGR(data));
};

export const useCreateBillMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createBills(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getBills"]);
    },
  });
};

export const useUpdateBillsMutation = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateBills(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getBills"]);
      queryClient.invalidateQueries(["getBillsDetails", `${id}`]);
      queryClient.invalidateQueries(["getBillsItems", `${id}`]);
    },
  });
};

export const useApproveOrRejectBillsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => approveOrRejectBills(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getBills"]);
    },
  });
};

export const useDeleteBillsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteBills(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getBills"]);
    },
  });
};

export const useDownloadBillsMutation = () => {
  return useMutation((data) => downloadBills(data));
};

export const useCreatePOCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createPOCategory(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPOCategories"]);
    },
  });
};

export const useUpdatePOCategoryMutation = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updatePOCategory(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPOCategories"]);
      queryClient.invalidateQueries(["getPOCategories", `${id}`]);
    },
  });
};

export const useDeletePOCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deletePOCategory(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPOCategories"]);
    },
  });
};

export const useUpdatePO = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updatePOSupplier(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getPurchaseOrderDetails", `${id}`]);
      queryClient.invalidateQueries(["getPurchaseOrders"]);
    },
  });
};
